export default __webpack_public_path__ + "static/media/web-project-1.dbc2198e.jpg";